var _react_refresh_temp_1, _react_refresh_temp_2;
var _react_refresh_temp_3;
_react_refresh_temp_3 = $RefreshSig$();
import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react-hooks/exhaustive-deps -- Intentional*/
/* eslint-disable @typescript-eslint/no-unsafe-assignment -- Intentional */
import { memo, useCallback, useMemo } from 'react';
import { C } from '#integrations';
import { INITIAL_RESET_RECORD_KEY, NO_RESET_KEY, STORAGE_RESET_KEY, } from '../../constants';
import { FormContextInstance } from '../../context';
import { useUpdate, useUpdateOnly } from '../../custom-hooks';
import { useFormReducer, useRootForm, useWizard } from '../../hooks';
import { FormEditProvider, FormRootProvider } from '../../providers';
import { formObjectReducer } from '../../reducers';
import { flattenFormObjectState } from '../../services';
import { FormRootTestIdFactory } from './interactions';
import styles from './FormRoot.module.css';
const defaultTouchParent = () => { };
export const FormRoot = memo(_react_refresh_temp_1 = _react_refresh_temp_3(({ children, className, 'data-testid': testid, initialResetState, initialWizardStep, isFullHeight = false, isUsingStorage, noValidate = true, onChange, onReset, onSubmit, onWizardCancel: onWizardCancelProp, onWizardSuccess: onWizardSuccessProp, }) => {
    _react_refresh_temp_3();
    const { context, isValid, isValidating, removeFromForm, setInForm, value, } = useFormReducer({
        flattenState: flattenFormObjectState,
        reducer: formObjectReducer,
    });
    const { cancel, edit, errors, fieldsToBeSet, focusedField, focusField, forceValidate, forceValidateFlag, getFieldId, injectedErrors, injectErrors, isEdit, isPristine, registerFieldErrors, reset, resetFlag, resetRecords, save, scrolledField, scrollFieldIntoView, setDirty, setFieldsValue, setIsPristine, setResetFlag, setResetRecords, } = useRootForm({
        formData: value,
        initialResetState,
        isUsingStorage,
    });
    const { onWizardCancel, onWizardSuccess, setWizardStep, wizardStep } = useWizard({
        initialWizardStep: initialWizardStep,
        onWizardCancel: onWizardCancelProp,
        onWizardSuccess: onWizardSuccessProp,
    });
    useUpdate(() => {
        if (!isPristine && onChange) {
            onChange({
                errors,
                isPristine,
                isValid,
                isValidating,
                resetState: resetRecords[INITIAL_RESET_RECORD_KEY],
                value,
            });
        }
    }, [errors, isPristine, isValid, isValidating, value]);
    // This will sync the errors
    // and isValid after reset:
    useUpdate(() => {
        if ((resetFlag.resetKey === INITIAL_RESET_RECORD_KEY ||
            resetFlag.resetKey === STORAGE_RESET_KEY ||
            resetFlag.resetKey === NO_RESET_KEY) && // This prevents StrictMode breaking the behavior
            isPristine &&
            isUsingStorage &&
            onChange) {
            onChange({
                errors,
                isPristine,
                isValid,
                isValidating,
                resetState: null,
                value,
            });
        }
    }, [errors, isValid, isValidating, resetFlag], true);
    useUpdateOnly(() => {
        if (onReset &&
            (resetFlag.resetKey === INITIAL_RESET_RECORD_KEY ||
                resetFlag.resetKey === STORAGE_RESET_KEY)) {
            onReset();
        }
    }, [resetFlag]);
    const methods = useMemo(() => ({
        blurParent: defaultTouchParent,
        cancel,
        edit,
        focusField,
        focusParent: defaultTouchParent,
        forceValidate,
        getFieldId,
        registerFieldErrors,
        removeFromForm,
        reset,
        save,
        scrollFieldIntoView,
        setFieldsValue,
        setInForm,
        touchParent: defaultTouchParent,
    }), [cancel, edit, save, reset]);
    const formContext = useMemo(() => {
        return {
            ...context,
            fieldsToBeSet,
            focusedField,
            forceValidateFlag,
            isEdit,
            isFocused: false,
            isValid,
            methods,
            scrolledField,
        };
    }, [
        context,
        fieldsToBeSet,
        focusedField,
        forceValidateFlag,
        isEdit,
        isValid,
        methods,
        scrolledField,
    ]);
    const rootProviderMethods = useMemo(() => ({
        focusField,
        forceValidate,
        injectErrors,
        registerFieldErrors,
        reset,
        scrollFieldIntoView,
        setDirty,
        setIsPristine,
        setFieldsValue,
        setResetFlag,
        setResetRecords,
    }), []);
    const onSubmitHandler = useCallback((event) => {
        event.preventDefault();
        if (onSubmit) {
            onSubmit({
                formState: { isValid, isValidating, value },
                rootMethods: rootProviderMethods,
            });
        }
    }, [isValid, isValidating, onSubmit, rootProviderMethods, value]);
    const formRootContext = useMemo(() => {
        return {
            errors,
            fieldsToBeSet,
            focusedField,
            formData: value,
            injectedErrors,
            isPristine,
            isUsingStorage,
            isValidating,
            methods: rootProviderMethods,
            onWizardCancel,
            onWizardSuccess,
            resetFlag,
            resetRecords,
            scrolledField,
            setWizardStep,
            wizardStep,
        };
    }, [
        errors,
        fieldsToBeSet,
        focusedField,
        injectedErrors,
        isPristine,
        isUsingStorage,
        isValidating,
        onWizardCancel,
        onWizardSuccess,
        resetRecords,
        rootProviderMethods,
        resetFlag,
        scrolledField,
        value,
        setWizardStep,
        wizardStep,
    ]);
    return (_jsx(FormEditProvider, { isEdit: isEdit, children: _jsx(FormContextInstance.Provider, { value: formContext, children: _jsx(FormRootProvider, { value: formRootContext, children: _jsx("form", { className: C(styles.FormRoot, className, isFullHeight && styles.FullHeight), "data-pristine": isPristine, "data-testid": FormRootTestIdFactory.getFormRootTestId(testid), noValidate: noValidate, onSubmit: onSubmitHandler, children: children }) }) }) }));
}, "rstUbxs5Q2UGuiAqhbz4AGOFB6E=", false, () => [useFormReducer, useRootForm, useWizard, useUpdate, 
    // This will sync the errors
    // and isValid after reset:
    useUpdate, useUpdateOnly]));
$RefreshReg$(_react_refresh_temp_1, "FormRoot$memo");
_react_refresh_temp_2 = FormRoot;
$RefreshReg$(_react_refresh_temp_2, "FormRoot");
FormRoot.displayName = 'FormRoot';
